import React from "react";
import { Route } from "react-router-dom";
import Seo from "./Seo";
import seoConfig, { NOT_FOUND_SEO } from "../../seoConfig";

function humanize(segment) {
  if (!segment) return "";
  const words = segment
    .replace(/[-_]/g, " ")
    .replace(/([a-z])([A-Z])/g, "$1 $2")
    .trim();
  return words.charAt(0).toUpperCase() + words.slice(1);
}

function fallbackTitle(path) {
  const lastSegment = (path || "").split("/").filter(Boolean).pop();
  return humanize(lastSegment) || "Tech Venture LLC";
}

/**
 * Drop-in replacement for react-router's <Route> that also injects unique
 * per-page <title>/<meta description>/canonical tags from src/seoConfig.js,
 * keyed by the static route path. Routes with a dynamic segment (e.g.
 * "/systemDesign/:slug") fall back to a title derived from the URL param.
 */
export default function SeoRoute({ path, component: RouteComponent, exact, ...rest }) {
  const meta = path ? seoConfig[path] || {} : NOT_FOUND_SEO;
  const paramSegments = (path || "").split("/").filter((seg) => seg.startsWith(":"));
  const hasParam = paramSegments.length > 0;

  return (
    <Route
      path={path}
      exact={exact}
      {...rest}
      render={(routeProps) => {
        let title = meta.title;
        if (!title && hasParam) {
          const paramName = paramSegments[0].slice(1);
          const paramValue = routeProps.match.params[paramName];
          title = fallbackTitle(paramValue) || fallbackTitle(path);
        } else if (!title) {
          title = fallbackTitle(path);
        }

        return (
          <>
            <Seo
              title={title}
              description={meta.description}
              path={routeProps.location.pathname}
              canonicalPath={meta.canonicalPath}
              noindex={Boolean(meta.noindex)}
            />
            <RouteComponent {...routeProps} />
          </>
        );
      }}
    />
  );
}
